import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getCurrentLocationShapeSets(organisationId, isAllocatedTo = true, shapeType=undefined, excludeArchived = true) {
  return function(dispatch, getState) {
    const endpoint = '/shapesets';
    const options = {
      method: "GET",
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        isAllocatedTo,
        excludeArchived
      }
    };

    if (shapeType) {
      options.params.shapeType = shapeType;
    }

    return makeAPICall(endpoint, options).then(
      response => {
        const shapeSets = response.data.shapeSets;
        const type = isAllocatedTo ? 'UPDATE_CURRENT_LOCATION_ALLOCATED_SHAPESETS' : 'UPDATE_CURRENT_LOCATION_UNALLOCATED_SHAPESETS';
        dispatch({ type, shapeSets });
      },
      error => dispatch(APIError(error, 'Error getting ShapeSets'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/locations/shapeSetCreators.js